import { Product } from "@/types/products";
import Card from "./Card";

interface CardGridProps {
  products: Product[];
}

const CardGrid = ({ products }: CardGridProps) => {
  return (
  <div className="lc-container lc-mx-auto">
    <div className="lc-flex lc-flex-col lg:lc-flex-row lc-gap-6 lc-font-azo-sans">
      <Card
        imageSrc={products[0].image}
        title={products[0].name}
        body={products[0].description}
        categories={[
          {
            title: "Level",
            text: products[0].difficulty,
          },
          { title: "Commitment", text: products[0].studyTime},
          { title: "Learning Mode", text: products[0].learningMode },
        ]}
        topPicks
        button={{
          text: products[0].linkLabel,
          type: "primary",
          url: products[0].url,
          size: "sm",
        }}
      />
      <Card
        imageSrc={products[1].image}
        title={products[1].name}
        body={products[1].description}
        categories={[
          { title: "Level", text: products[1].difficulty },
          { title: "Commitment", text: products[1].studyTime },
          { title: "Learning Mode", text: products[1].learningMode },
        ]}
        button={{
          text: products[1].linkLabel,
          type: "quaternary",
          url: products[1].url,
          size: "sm",
        }}
      />
      <Card
        imageSrc={products[2].image}
        title={products[2].name}
        body={products[2].description}
        categories={[
          { title: "Level", text: products[2].difficulty },
          { title: "Commitment", text: products[2].studyTime },
          { title: "Learning Mode", text: products[2].learningMode },
        ]}
        button={{
          text: products[2].linkLabel,
          type: "quaternary",
          url: products[2].url,
          size: "sm",
        }}
      />
    </div>
  </div>
)};

export default CardGrid;
